import React from 'react';
import { PRODUCTS } from '../../data/portal';
const STYLE: Record<string, string> = {
  solution: 'text-[#A9C9FF]',
  gov: 'text-royal'
};
const DOT: Record<string, string> = {
  solution: 'bg-[#8DB8FF]',
  gov: 'bg-gold'
};

/** The brand a project or organisation sits under. Every product registered in the store gets one. */
export function ProductTag({
  productId,
  className = ''
}: {
  productId: string;
  className?: string;
}) {
  const product = PRODUCTS.find(p => p.id === productId);
  if (!product) return null;
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap text-[12px] font-medium ${STYLE[product.slug] ?? 'text-body'} ${className}`} data-id="element-1039" data-mp="1dvb0syvq8pix">
      <span className={`h-2 w-2 rounded-[3px] ${DOT[product.slug] ?? 'bg-body'}`} aria-hidden="true" data-id="element-1040" data-mp="1muoa9rjupe3n" />
      {product.name}
    </span>;
}